export default __webpack_public_path__ + "static/media/main-image.aef170ea.png";